// Module
var code = "<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M5 0L0 5.83333H3.33333V10H6.66667V5.83333H10L5 0Z\" fill=\"#3BB54A\"/> </svg> ";
// Exports
module.exports = code;